import React from 'react'
import { CtiImageCompound } from '../blogArticle/componentTypes/CtiImageCompound.jsx'
import './blogArticleWhitePaper.css'
import { Link2 } from '../../link/link.jsx'

function BlogArticleWhitePaper({
  title,
  overline,
  linkText,
  linkHref = '',
  imageUrl,
  alt,
  content,
  asButton = false,
}) {
  return (
    <div
      className={`u-posRelative u-marginBottom6gu ${
        !imageUrl ? 'u-sizeConstrainedNarrow' : ''
      } u-sizeConstrained`}
    >
      <div className="u-flex u-flexCol" key={title}>
        <div
          className="u-posRelative bannerType-video u-decoBorderLight u-decoBorderResetBottom"
          id={name}
        >
          <div className="u-flex u-flexWrap white-paper-wrapper">
            {imageUrl ? (
              <CtiImageCompound
                imageUrl={imageUrl}
                alt={alt}
                classNames="u-posAbsolute u-sm-posRelative u-size2of12 u-sm-size6of12 white-paper-image"
                imgClasses="u-sizeFull u-paddingVert0"
                downloadUrl={linkHref}
              />
            ) : null}
            <div className="outerContainer u-posRelative u-sizeFull white-paper-card-content">
              <div className="u-flex u-flexCol u-sm-paddingVert4gu u-flexAlignItemsStart full-height">
                <div className="u-flex u-sizeFull u-flexJustifyStart">
                  <div
                    className={`u-flex u-flexCol u-flexAlignItemsStart ${
                      imageUrl ? 'u-size10of12' : 'u-size12of12'
                    } u-sm-sizeFull u-paddingVert8gu u-sm-paddingVert0 u-md-paddingVert4gu u-paddingRight4gu u-sm-paddingRight0`}
                  >
                    {overline ? (
                      <div className="u-marginBottom4gu">
                        <div className="u-bgColorBrandExtraLight u-marginBottom1gu white-paper-title"></div>
                        <div className="u-textUppercase u-textBold">
                          {overline}
                        </div>
                      </div>
                    ) : null}
                    {title ? (
                      <h3 className="u-textColorBrand u-textBold">{title}</h3>
                    ) : null}
                    {content ? (
                      <div
                        className="Content u-marginBottom2gu u-sizeFull u-textBreak"
                        dangerouslySetInnerHTML={{ __html: content }}
                      ></div>
                    ) : null}
                    {linkHref ? (
                      <Link2
                        url={linkHref}
                        text={linkText}
                        arrow={asButton ? '' : 'brand'}
                        className={`${
                          asButton
                            ? 'Button Button--secondary u-textColorBrandLight u-decoBorderBrandLight'
                            : 'Link u-posRelative hover-underline-animation'
                        } u-paddingTop2gu`}
                        textClasses={`u-textSecondary u-textKernLoose`}
                      />
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export { BlogArticleWhitePaper }
